import React, { useEffect, useState } from "react";
import { Link } from 'gatsby';
import Layout from "../layout";
import LazyLoad from 'react-lazyload';
import { decode } from 'he';
import ConvertHTMLToText from "../common/utils/html-to-text";
import TagSelect from './tagSelect';
import SEO from "../seo";
import IconArrowRight from "../../icons/arrow-right.svg";
import { Helmet } from "react-helmet";
import TagBlogPagination from '../common/templates/tagBlogPagination'

const loader = <li className="list-item d-flex flex-wrap"></li>;

const TagBlogList = (props) => {
  const [currentPage, setCurrentPage] = useState();
  //const layOutRef = useRef(null);
  const stories = props.data.data.allWordpressPost.edges;
  const tags = props.data.data.allWordpressTag.edges;
  const pageContext = props.data.pageContext;
  const [pageTitle, setPageTitle] = useState();

  useEffect(() => {
    /* if(pageContext.humanPageNumber === 1){
      layOutRef.current.classList.add("blogListingFirstPage");
    }
    else{
      layOutRef.current.classList.remove("blogListingFirstPage");
    }  */

    if (props.tag === "Retail") {
      setPageTitle("Retail Industry Insights")
    }
    if (props.tag === "Manufacturing") {
      setPageTitle("Manufacturing Industry Insights")
    }
    if (props.tag === "Logistics") {
      setPageTitle("Logistics Industry Insights")
    }
    if (props.tag === "Healthcare") {
      setPageTitle("Healthcare Industry Insights")
    }

  }, [])


  const blogList = stories.map((story, i) => {

    let lendingPageUrl;
    let blogContent = ConvertHTMLToText({ html: decode(story.node.content) });
    const wpm = 200;
    const totalWords = blogContent.trim().split(/\s+/).length;
    const readTime = Math.ceil(totalWords / wpm);

    if (story.node.acf.lending_page_image === null) {
      lendingPageUrl = story.node.featured_media.source_url
    }
    else {
      lendingPageUrl = story.node.acf.lending_page_image.source_url
    }

    return (
      <LazyLoad key={i} placeholder={loader}>
        <li className="list-item d-flex flex-wrap">
          <div className="list-image">
            <Link to={'/blog/' + story.node.slug + '/'}>
              <LazyLoad><img src={lendingPageUrl} alt={story.node.featured_media.alt_text} /></LazyLoad>
            </Link>
          </div>
          <div className="list-info">
            <div className="list-category-name">{
              story.node.categories.map((category, i) => {
                return (
                  <Link key={i} to={'/blog/category/' + category.slug + '/'}>
                    {decode(category.name)}
                  </Link>);
              })
            }
              <span className="list-category-time">{readTime} min read</span>
            </div>

            <h3 className="list-title">
              <Link to={'/blog/' + story.node.slug + '/'}> {decode(story.node.title)} </Link>
            </h3>
            <p className="read-link">
              <Link to={'/blog/' + story.node.slug + '/'} className="big">Read Story <IconArrowRight /></Link>
            </p>
            <p className="desc"> {ConvertHTMLToText({ html: decode(story.node.content), length: 75 })} </p>
          </div>
        </li>
      </LazyLoad>);
  });

  return (
    <Layout addBodyClass="blog-list-page blog-landing-page white-header" footerFormType="basic" id="BlogListPaginationLayout" >
      <SEO description="Rapidops Blog - Get insightful updates on what’s trending in technology, innovation and mobility industry along with latest news about Rapidops."
        meta={[{ name: "charSet", content: "utf-8" }]}
        title="Updates on Technology, Innovation, Mobility Solutions - Official Blog" />
      {('Everything' !== props.category) && <Helmet>
        <meta name="robots" content="noindex"></meta>
      </Helmet>}
      <div className="blog-listing-section section-gap">
        <div className="blog-top-bar">
          <div className="container">
            <p className="blog-quote-text uppercase">our THINKING on DIGITAL, DATA & AI</p>
            <h1 className="blog-title">Ideate. Innovate. Implement.</h1>
          </div>
        </div>
        <div className="blog-listing-section">
          <div className="container">
            <div className="blog-top-category">
              <div className="page-category-bar">
                <ul className="left-navlist">
                  <li>
                    <Link to={`/blog/`}>{`EXPLORE (${pageContext.totalBlogCount})`}</Link>
                  </li>
                  {tags.map((tag, index) => {
                    const tagName = decode(tag.node.name);
                    return <li className={tag.node.name === props.tag ? "active" : ""} key={index}><Link to={`/blog/tag/${tag.node.slug}/`}>{`${tagName} (${tag.node.count})`}</Link></li>;
                  })}
                </ul>
                <TagSelect tags={tags} currentTag={decode(props.tag)} />
              </div>
              <div className="underline-title">
                <h2><span>{pageTitle}</span></h2>
              </div>
            </div>

            <div className="page-content-bar">
              <ul className="list-row">
                {blogList}
              </ul>
              <TagBlogPagination
                className="pagination-bar"
                currentPage={pageContext.humanPageNumber}
                totalPageCount={pageContext.numberOfPages}
                onPageChange={page => setCurrentPage(page)}
                nextPageUrl={pageContext.nextPagePath}
                previousPageUrl={pageContext.previousPagePath}
                tag={pageContext.tagSlug}
              />
            </div>
          </div>
        </div>
      </div>

      {
        (pageContext.tagsBlogCount >= 9) && 
        <div className="section-gap blog-listing-cta">
          <div className="container">
            <div className="dt-cta-section">
              <div className="dt-cta-inner">
                <div className="leftbar">
                  <h2>Rapidops help {pageContext.tagSlug} businesses leverage cloud & data to create exceptional customer experiences.</h2>
                </div>
                <div className="rightbar">
                  <Link className="button button-white right-arrow" to={`/industries/${pageContext.tagSlug}/`}>Learn More</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      

    </Layout>
  )
};


export default TagBlogList;